/**
 * @deprecated use PDS colors from `theme` instead.
 */
export const COLORS = {
  indigo100: '#290087',
  indigo80: '#4700EB',
  indigo60: '#7E66B6',
  indigo20: '#D4CCE7',
  indigo10: '#F1EBFF',
  yellow100: '#FFDC82',
  yellow10: '#FFF8E6',
  green100: '#62D284',
  green10: '#E0F6E6',
  red100: '#E60541',
  red60: '#FF8F88',
  red10: '#FFE0DE',
  gray100: '#1E1B17',
  gray70: '#625F5D',
  gray50: '#9394A1',
  gray20: '#D2D1D1',
  gray8: '#EDEDEC',
  gray4: '#F6f6f7',
  black: '#000000',
  white: '#FFFFFF',
};

/*
 * Prefer adding these values together instead of adding new ones if possible.
 */
export const Z_INDICES = {
  withShadow: 1,

  sticky: 2,

  loadingOverlays: 5,

  tooltip: 10,

  floatingBar: 100,

  /*
   * The main levels we have in dashboard
   */
  topNav: 1000,
  dropdown: 1001,
  layeredDropdown: 1002,
  banner: 2000,
  sideNav: 3000,
  topNavTooltip: 3001,
  modal: 10000,
  /*
   * For elements that should expand out of modals, but NOT cover things like dropdowns
   */
  modalElevated: 10001,
  modalDropdown: 10010,
  supportChat: 10011,
  toast: 100000,
} as const;

export type ZIndex = (typeof Z_INDICES)[keyof typeof Z_INDICES];

export const WIDTHS = {
  nullStateImage: '350px',
};

export const TEXT_DECORATIONS_LINE = {
  none: 'none',
  underline: 'underline',
};
